import { Link } from "react-router-dom";
import styles from "./shell.module.css";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  if (items.length === 0) return null;
  return (
    <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`}>
            {index > 0 ? <span className={styles.crumbSep}>/</span> : null}{" "}
            {isLast || !item.to ? (
              <span className={styles.crumbCurrent} aria-current="page">
                {item.label}
              </span>
            ) : (
              <Link className={styles.crumb} to={item.to}>
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
